import React from "react";

const Volunteer = () => (
    <div className="row volunteer">
	<div className="three columns header-col">
	    <h1>
		<span>Volunteer</span>
	    </h1>
	</div>
	
	<div className="nine columns main-col">
	          <div className="row item">
	            <div className="twelve columns">
	              <h4 className="mb0">Wagner Food Policy Alliance Board</h4>
	              <p className="info">
	                Finance Chair
	                <span>&bull;</span>
	                <em className="date">2018 to Present</em>
	              </p>
	    
	              <p>
	    	      A coalition within the NYU community working toward a just and sustainable food system
	              </p>
	            </div>
	          </div>
	          <div className="row item">
	            <div className="twelve columns">
	              <h4 className="mb0">Universities Fighting World Hunger</h4>
	              <p className="info">
	                Hackathon Consultant and Organizer
	                <span>&bull;</span>
	                <em className="date">2019 to Present</em>
	              </p>
	    
	              <p>
	    	      Assist University of Maine host their first hackathon in conjunction with their UFWH international summit
	              </p>
	            </div>
	          </div>
	          <div className="row item">
	            <div className="twelve columns">
	              <h4 className="mb0">HackNYU</h4>
	              <p className="info">
	                Sustainability and Social Impact Track Chair
	                <span>&bull;</span>
	                <em className="date">2016 to Present</em>
	              </p>
	    
	              <p>
	    	      Annual global hackathon
	              </p>
	            </div>
	          </div>
	          <div className="row item">
	            <div className="twelve columns">
	              <h4 className="mb0">Association to Benefit Children</h4>
	              <p className="info">
	                Resident Teaching Artist
	                <span>&bull;</span>
	                <em className="date">2015</em>
	              </p>
	    
	              <p>
	    	      Taekwondo after school program
	              </p>
	            </div>
	          </div>
	          <div className="row item">
	            <div className="twelve columns">
	              <h4 className="mb0">Brooklyn College TKD Club</h4>
	              <p className="info">
	                Founder, Faculty Advisor
	                <span>&bull;</span>
	                <em className="date">2009 to 2016</em>
	              </p>
	    
	              <p>
	    	      National competition team
	              </p>
	            </div>
	          </div>
	          <div className="row item">
	            <div className="twelve columns">
	              <h4 className="mb0">VisCorps</h4>
	              <p className="info">
	                Educational Director, Senior Instructor
	                <span>&bull;</span>
	                <em className="date">2014 to 2015</em>
	              </p>
	    
	              <p>
	    	      Mentorship for success startup
	              </p>
	            </div>
	          </div>
	          <div className="row item">
	            <div className="twelve columns">
	              <h4 className="mb0">Free Self Defense Seminars</h4>
	              <p className="info">
	                Organizer, Teacher
	                <span>&bull;</span>
	                <em className="date">2009 to 2012</em>
	              </p>
	    
	              <p>
	    	      Partnered with organizations and departments at Brooklyn College
	              </p>
	            </div>
	          </div>
	          <div className="row item">
	            <div className="twelve columns">
	              <h4 className="mb0">Brooklyn College</h4>
	              <p className="info">
	                Selection Committee, Faculty Chair
	                <span>&bull;</span>
	                <em className="date">2010 to 2015</em>
	              </p>
	    
	              <p>
	    	      Study abroad scholarship of $1,000
	              </p>
	            </div>
	          </div>
	          <div className="row item">
	            <div className="twelve columns">
	              <h4 className="mb0">Big Brothers Big Sisters of America</h4>
	              <p className="info">
	                Big Brother Mentor
	                <span>&bull;</span>
	                <em className="date">2008 to 2009</em>
	              </p>
	    
	              <p>
	    	      Youth mentoring organization
	              </p>
	            </div>
	          </div>
	          <div className="row item">
	            <div className="twelve columns">
	              <h4 className="mb0">Speak For Yourself</h4>
	              <p className="info">
	                Cofounder, Performer
	                <span>&bull;</span>
	                <em className="date">2004 to 2007</em>
	              </p>
	    
	              <p>
	    	      Slam poetry club at Boston University
	              </p>
	            </div>
	          </div>
	          <div className="row item">
	            <div className="twelve columns">
	              <h4 className="mb0">Intercollegiate Slam Team</h4>
	              <p className="info">
	                Founder, Performer
	                <span>&bull;</span>
	                <em className="date">2006 to 2007</em>
	              </p>
	    
	              <p>
	    	      Regionally touring slam poetry team
	              </p>
	            </div>
	          </div>
        </div>
    </div>
);

export default Volunteer;



// WEBPACK FOOTER //
// ./src/components/resume/Volunteer.jsx